import { initialProps } from '@utils/initial'
import { Container, Row, Col } from 'react-bootstrap'
import { FaArrowLeft } from 'react-icons/fa'
import advisors from '@components/wellness/NutritionalAdvisorsData'
import { HomeWellnessLayout, MeetExperts, YWPCreateAccount} from '@components/Block'
import Link from 'next/link'

export async function getServerSideProps({req, res, query}) {
    return {
        props: await initialProps(req, res, query)
    }
}

function NutritionalAdvisors (props) {
    
    return (
        <HomeWellnessLayout global={props}>
            <MeetExperts site={props}/>
            <div className="expert__Advisors py-5 text-black mt-5">
                <Container>
                    {advisors.map((data, idx) => (
                        <Row key={idx} className="mb-5">
                            <Col lg={3} md={12}>
                                <img className="expert__Advisors--img img-fluid mx-auto" width={218} src={data.image} alt={data.name}/>
                            </Col>
                            <Col lg={9} md={12}>
                            <div className="float-right expert__Advisors--desc">
                                <h2 className="text-green"><strong>{data.name}</strong></h2>
                                {data.desc}
                            </div>
                            {data.url != '' ? (<Link href={data.url}><a className="text-blue"><u>View Bio</u></a></Link>) : "" }
                            </Col>
                        </Row>
                    ))}
                    <div className="text-center py-4">
                        <YWPCreateAccount site={props} bgcolor="bg-green" txtcolor="text-white"/>
                        <Link href="/"><a className="mx-auto text-reset d-block mt-2 text-decoration-none"><FaArrowLeft className="mr-2"/> Go back</a></Link>
                    </div>
                </Container>
            </div>

        <style jsx>{`
            .expert__Advisors{
                background-image: url(../images/home/img-element-left-side.png), url(../images/home/img-element-right-side.png);
                background-position: left 55px, right 55px;
                background-repeat: no-repeat;
            }
            
            @media (max-width: 1024px){
            .expert__Advisors {
                background-image: none;
            }
            `}
        </style>
        </HomeWellnessLayout>
    )
}

export default NutritionalAdvisors